/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import { useIsMobile, useIsPc } from 'core/hooks/useResponsive';
import list1Img from 'static/company/section3_list1.png';
import list2Img from 'static/company/section3_list2.png';
import list3Img from 'static/company/section3_list3.png';
import list4Img from 'static/company/section3_list4.png';
import { motion } from 'framer-motion';

const Section3 = () => {
  const { mq } = useTheme();
  const isMobile = useIsMobile();
  const isPc = useIsPc();

  const Section3Style = css`
    padding-bottom: 200px;
    .container {
      width: 1352px;
      margin: 0 auto;
      .title {
        font-size: 56px;
        font-style: normal;
        font-weight: 700;
        line-height: 76px;
        span {
          color: #87b0ca;
        }
      }
      ul {
        display: flex;
        gap: 24px;
        margin-top: 48px;
        li {
          width: 320px;
          img {
            width: 100%;
          }
        }
      }
    }
    ${mq.mobile} {
      padding-bottom: 96px;
      .container {
        width: 100%;
        padding: 0px 0px 48px 0px;
        .title {
          padding-left: 20px;
          font-size: 32px;
          line-height: 42px;
          span {
            color: #6079ff;
          }
        }
        .scroll {
          width: 100%;
          overflow-x: scroll;
          padding: 0 20px 10px 20px;
          overflow-y: hidden;
          ul {
            margin-top: 40px;
            width: 996px;
            gap: 12px;
          }
        }
      }
    }
  `;

  const XVariants = {
    offscreen: {
      x: -200,
      opacity: 0,
    },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };
  const yVariants = {
    offscreen: {
      y: 100,
      opacity: 0,
    },
    onscreen: {
      y: 0,
      opacity: 1,
    },
  };

  return (
    <div css={Section3Style}>
      <div className="container">
        <motion.h2
          initial="offscreen"
          whileInView="onscreen"
          variants={XVariants}
          className="title"
        >
          <span>국내 대표 기업이 선택한</span>
          <br />
          몰파이 커머스
        </motion.h2>
        <div className="scroll">
          <ul>
            <li>
              <motion.img
                initial="offscreen"
                whileInView="onscreen"
                variants={yVariants}
                transition={{ duration: isMobile ? 0.5 : 0.3 }}
                src={list1Img}
                alt="유플러스 콕 | 이미지"
                title="유플러스 콕"
              />
            </li>
            <li>
              <motion.img
                initial="offscreen"
                whileInView="onscreen"
                variants={yVariants}
                transition={{ duration: isMobile ? 0.5 : 0.4 }}
                src={list2Img}
                alt="페이코 | 이미지"
                title="페이코"
              />
            </li>
            <li>
              <motion.img
                initial="offscreen"
                whileInView="onscreen"
                variants={yVariants}
                transition={{ duration: isMobile ? 0.5 : 0.5 }}
                src={list3Img}
                alt="하나카드 | 이미지"
                title="하나카드"
              />
            </li>
            <li>
              <motion.img
                initial="offscreen"
                whileInView="onscreen"
                variants={yVariants}
                transition={{ duration: isMobile ? 0.5 : 0.6 }}
                src={list4Img}
                alt="HBAF | 이미지"
                title="HBAF"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Section3;
